/** Application session — the Vue face of src/core/state/app.ts (see core/state/mirror.ts). Phase 1B. */
import { mirrorStore } from '@/core/state/mirror'
import { appStore, appSelectors, appActions } from '@/core/state/app'

export const useAppStore = mirrorStore('app', appStore, { selectors: appSelectors, actions: appActions })
